<template>
  <div>
    <div class="bread">
      <span class="returnBtn" @click="returnFun">返回上一页</span>
      <!-- <span class="breadOne">首页</span> -->
      <div style="display:inline-block;" v-for="(item,index) in breadChild">
        
        <span
          class="breadAfter marginLeft10"
          :style="{color: (index === breadChild.length-1 ? 'rgba(204, 204, 204, 1)':'rgba(102, 102, 102, 1)')}"
        >{{item}}</span>
        <img :src="breadLeftImg" v-show="index != breadChild.length-1" class="marginLeft10" alt>
      </div>
    </div>
  </div>
</template>
<script>
import breadLeftImg from "@/assets/images/breadLeftImg.png";

export default {
  name: "Bread",
  props: ["breadChild"],
  data() {
    return {
      breadLeftImg: breadLeftImg
    }
  },
  methods:{
    returnFun(){
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.bread {
  margin-left: 13%;
  margin-top: 28px;
}
.breadOne {
  display: inline-block;
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.breadAfter {
  display: inline-block;
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
}
.marginLeft10 {
  margin-left: 3px;
}
.returnBtn {
  cursor: pointer;
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(251, 199, 46, 1);
  display: inline-block;
  margin-right: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/bread.vue